import { numberIsFinite } from "@gameApp/helpers/numbers/numberIsFinite";

export function miniGameOrderRewardAmount(
  reward = 0,
  winStreakMultiplier = 0,
  coefficient = 1,
): string {
  const rewardAmount = (1 + winStreakMultiplier / 100) * reward * coefficient;

  if (numberIsFinite(rewardAmount)) {
    return Math.round(rewardAmount).toLocaleString("en-US");
  }

  return "--";
}
